import {
  Button,
  Container,
  FormControl,
  Stack,
  SxProps,
  TextField,
  Typography,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import {
  CircularProgressModal,
  GreenPaper,
} from "../../components";
import { useState } from "react";
import { enqueueSnackbar } from "notistack";
import { axiosInstance } from "../../utils";
import Header from "../../web/src/components/Header";
import Footer from "../../web/src/components/Footer";

export const RefLoginPage = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const ButtonHover: SxProps = {
    "&:hover": {
      color: "white",
      backgroundColor: "#ed6c02"
    }
  }

  const onSubmit = async (event: any) => {
    event.preventDefault();
    setLoading(true);

    try {
      await axiosInstance.post("/reference/login/email", { email });
      enqueueSnackbar("Giriş bağlantısı mail adresine gönderildi.", {
        variant: "success",
      });

      navigate("/");
    } catch (error) {
      enqueueSnackbar("Beklemedik bir hata oluştu.", { variant: "error" });
    }

    setLoading(false);
  };

  return (
    <>
      <div className="web-app-new-project-1234">
        <Header />
      </div>
      <Container
        sx={{
          pb: 4,
          
          display: "flex",
          flexDirection: "column",
        }}
      >
          <Stack
            gap={2}
            sx={{ p: 3, py: 6, alignItems: "center", justifyContent: "center" }}
          >
            <form onSubmit={onSubmit} style={{ maxWidth: 400, width: "100%" }}>
              <Stack
                gap={3}
                sx={{
                  border: "1px solid",
                  borderColor: "divider",
                  p: 3,
                  width: "100%",
                  borderRadius: 2,
                }}
              >
                <Typography sx={{ fontSize: "24px", fontWeight: "bold", color: "#ed6c02" }}>
                  Referanslarım
                </Typography>
                <Stack gap={0.25}>
                  <FormControl>
                    <TextField
                      required
                      label="Email"
                      color="warning"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </FormControl>
                  <Typography sx={{ fontSize: "12px", color: "grey.600" }}>
                    Giriş bağlantı linkini mail adresine göndereceğiz.
                  </Typography>
                </Stack>
                <Button
                  variant="outlined"
                  color="warning"
                  type="submit"
                  disabled={loading}
                  sx={ButtonHover}
                  
                >
                  Giriş Bağlantısı Gönder
                </Button>
              </Stack>
            </form>
          </Stack>
      </Container>
      <div className="web-app-new-project-1234">
        <Footer />
      </div>
    </>
  );
};
